import { memo } from 'react'
import Cross from '../../../images/Components/Cross'
import Plus from '../../../images/Components/Plus'
import Tick from '../../../images/Components/Tick'

interface DropMessageInterface {
  isDragReject: boolean
  isDragLimit: boolean
  isDragAccept: boolean
}

function DropMessage({
  isDragReject,
  isDragLimit,
  isDragAccept
}: DropMessageInterface) {
  if (isDragReject) {
    return (
      <>
        <div className="m-8">
          <Cross fill="#A20017" />
        </div>
        <p className="h4" style={{ color: '#A20017' }}>
          Unsupported file type
        </p>
        <span className="wc-assist">
          (Only *.jpeg, and*.png images or *.pdf documents will be accepted)
        </span>
      </>
    )
  }
  if (isDragLimit) {
    return (
      <>
        <div className="m-8">
          <Cross fill="#A20017" />
        </div>
        <p className="h4" style={{ color: '#A20017' }}>
          File limit reached
        </p>
        <span className="wc-assist">
          (Only *.jpeg, and*.png images or *.pdf documents will be accepted)
        </span>
      </>
    )
  }
  if (isDragAccept) {
    return (
      <>
        <div className="m-8">
          <Tick fill="#386323" />
        </div>
        <p className="h4" style={{ color: '#386323' }}>
          File is supported
        </p>
        <span className="wc-assist">
          (Only *.jpeg, and*.png images or *.pdf documents will be accepted)
        </span>
      </>
    )
  }
  return (
    <div className="w-100 flex flex-col justify-center items-center">
      <span className="mb-4">
        <Plus />
      </span>
      <p className="h6 mb-4">Drag ’n’ drop some files here</p>
      <p className="h6 mb-4">or</p>
      <p className="mb-4">
        <button type="button" className="link">
          Browse Files
        </button>
      </p>
      <span className="wc-assist">
        (Only *.jpeg, and*.png images or *.pdf documents will be accepted)
      </span>
    </div>
  )
}

export default memo<DropMessageInterface>(DropMessage)
